<template>
    <div class="records">
        <div class="records__title">
            <span class="records__bar custom-orange" />
            Καλύτερες επιδόσεις
        </div>
        <div class="records__grid">
            <div
                v-for="header in headers"
                :key="header.value"
                class="record-card"
                :class="{ 'record-card--empty': !hasRecord(header.value), 'record-card--link': hasRecord(header.value) }"
                @click="goToMatch(header.value)"
            >
                <div class="record-card__label">
                    <v-icon small color="orange">{{ header.icon }}</v-icon>
                    {{ header.text }}
                </div>
                <div class="record-card__value">{{ hasRecord(header.value) ? stats[header.value].value : '-' }}</div>
                <div v-if="hasRecord(header.value)" class="record-card__match">
                    <span class="record-card__opponent">{{ stats[header.value].team || team }} <span class="record-card__vs">vs</span> {{ stats[header.value].oponnent }}</span>
                    <span class="record-card__date">{{ getDate(header.value) }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import momentTimezone from 'moment-timezone'

    export default {
        props: {
            stats: {
                type: Object,
                default: null
            },
            team: {
                type: String,
                default: null
            }
        },
        data() {
            return {
                headers: [
                    { text: 'Πόντοι', value: 'points', icon: 'mdi-basketball' },
                    { text: 'Ριμπάουντ', value: 'rebounds', icon: 'mdi-basketball-hoop-outline' },
                    { text: 'Ασίστ', value: 'assists', icon: 'mdi-handshake-outline' },
                    { text: 'Εύστοχα δίποντα', value: 'twoPointsMade', icon: 'mdi-numeric-2-circle-outline' },
                    { text: 'Εύστοχα τρίποντα', value: 'threePointsMade', icon: 'mdi-numeric-3-circle-outline' },
                    { text: 'Εύστοχες βολές', value: 'freeThrowsMade', icon: 'mdi-target' },
                    { text: 'Κλεψίματα', value: 'steals', icon: 'mdi-hand-back-left-outline' },
                    { text: 'Κοψίματα', value: 'blockedShots', icon: 'mdi-cancel' },
                    { text: 'Λάθη', value: 'turnovers', icon: 'mdi-alert-circle-outline' }
                ]
            }
        },
        methods: {
            // Without games in the selected phase a record keeps its empty initial value (no match, no date)
            hasRecord(key) {
                return !!(this.stats && this.stats[key] && this.stats[key].matchId)
            },
            getDate(key) {
                return momentTimezone(this.stats[key].date).tz('Europe/Athens').locale('el').format('D MMMM YYYY')
            },
            goToMatch(key) {
                if (this.hasRecord(key)) {
                    this.$router.push({ name: 'Match', params: { id: this.stats[key].matchId } })
                }
            }
        }
    }
</script>

<style scoped>
.records {
    margin-top: 20px;
    font-family: Ubuntu, Arial, sans-serif;
    text-align: left;
}

.records__title {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 12px;
    padding: 8px 14px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    font-size: 1.1rem;
    font-weight: 800;
}

.records__bar {
    width: 5px;
    height: 20px;
    border-radius: 2px;
}

.records__grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 12px;
}

.record-card {
    padding: 14px;
    border-radius: 12px;
    background: #fff;
    border-top: 3px solid #ff7133;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.record-card--link {
    cursor: pointer;
}

.record-card--link:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.12);
}

.record-card--empty {
    opacity: 0.6;
}

.record-card__label {
    display: flex;
    align-items: center;
    gap: 6px;
    color: rgba(0, 0, 0, 0.6);
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.03em;
    text-transform: uppercase;
}

.record-card__value {
    margin-top: 4px;
    font-size: 2.2rem;
    font-weight: 800;
    line-height: 1.1;
}

.record-card__match {
    display: flex;
    flex-direction: column;
    margin-top: 6px;
    font-size: 0.82rem;
}

.record-card__opponent {
    font-weight: 700;
}

.record-card__vs {
    color: rgba(0, 0, 0, 0.45);
    font-weight: 500;
}

.record-card__date {
    color: rgba(0, 0, 0, 0.5);
}
</style>
